export default __webpack_public_path__ + "static/media/ic-delete.72d56983.svg";